module.exports = __webpack_public_path__ + "img/262.02e89795.jpg";